export type DraggableDefinitionData = {
	definitionId: string
}

export function isDraggableDefinition(data: unknown): data is DraggableDefinitionData {
	const castItem = data as DraggableDefinitionData
	return castItem.definitionId !== undefined
}